













































































import { Component, Vue } from "vue-property-decorator";
import { currentUserStore } from "@/store/typed";
import { User } from "../models";
import store from "../store";
import { UserRoles } from "@/models/User";

export interface SidebarItem {
  name?: string;
  icon: string;
  onClick?: any;
  disabled?: boolean;
  roles?: string[];
}

@Component
export default class TheSidebar extends Vue {
  topItems: SidebarItem[] = [
    {
      name: "scouting",
      icon: "menu-map",
      roles: ["anyone"],
    },
    {
      name: "companies_branch",
      icon: "menu-clients",
      roles: [
        UserRoles.ANALYST,
        UserRoles.ADMINISTRATOR,
        UserRoles.SUPERADMIN,
        UserRoles.SYSTEM_ADMIN,
      ],
    },
  ];

  bottomItems: SidebarItem[] = [
    {
      name: "settings",
      icon: "menu-settings",
      roles: [
        UserRoles.ADMINISTRATOR,
        UserRoles.SUPERADMIN,
        UserRoles.SYSTEM_ADMIN,
      ],
    },
    {
      onClick: this._logout,
      icon: "menu-logout",
      roles: ["anyone"],
    },
  ];

  get adminRoles() {
    return User.adminRoles.map((o) => o.id);
  }

  get sidebarTopItems() {
    return this.topItems;
  }

  get logoPath() {
    return require("@/assets/icons/logo.svg");
  }

  get user() {
    return currentUserStore.user;
  }

  open = false;

  get sidebarOpen() {
    return this.isTablet && !this.open;
  }

  get style() {
    return { "z-index": 2000 };
  }

  get isSystemAdmin(): boolean {
    if (!this.user) {
      return false;
    }

    return this.user.isSystemAdmin;
  }

  _logout() {
    store.dispatch("logout").then(() => {
      window.location.reload();
    });
  }

  get sidebarLoading() {
    return false;
  }

  routeActive(name: string) {
    return this.$isRouteActive(name);
  }

  get isTablet() {
    return this.$mq === "sm" || this.$mq === "md" || this.$mq === "lg";
  }
}
